import baseGetTag from './_baseGetTag.js'
import isObjectLike from './isObjectLike.js'

/** `Object#toString` result references. */
var argsTag = '[object Arguments]'

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag
}

export default baseIsArguments
